import React, { useState } from "react";
import { LoginBoxContent } from "../../styles/Auth";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faCheck,
  faExclamationTriangle,
  faEye,
  faEyeSlash,
  faTimes,
  faTimesCircle,
} from "@fortawesome/free-solid-svg-icons";
import { useAuthRequests } from "../../helpers/AuthRequests";
import { useDispatch } from "react-redux";
import { useCartRequests } from "../../helpers/CartRequests";
import { setBasket } from "../stores/Cart";
import { setCustomer, loginChange } from "../stores/Auth";
import { Bounce, Sentry } from "react-activity";

import robotkafasi from "../../images/dehasoft-robot-kafasi.png";
import { setForgotPopUp, setLoginPopUp, setRegisterPopUp } from "../stores/Site";
export default function ForgotBox({ open, setOpen, loginOpen }) {
  const { forgotRequest, forgotRequestFinal, getCustomer } = useAuthRequests();
  const { getCart } = useCartRequests();

  const dispatch = useDispatch();

  const [mode, setMode] = useState(1);
  const [code, setCode] = useState("");
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");

  const [error, setError] = useState("");
  const [success, setSuccess] = useState("");
  const [loading, setLoading] = useState(false);
  const [checked, setChecked] = useState(false);
  const [hide, setHide] = useState(true);

  const loginIn = async (e) => {
    e.preventDefault();
    
    setLoading(true);

    if(mode==1){
      forgotRequest(email)
        .then(async (response) => {
          setLoading(false);
          setError("");
          setMode(2)
          setSuccess("Doğrulama kodu eposta adresinize gönderildi");
        })
        .catch((error) => {
          setSuccess("");
          setError(error.response?.data?.message);
          setLoading(false);
        });
    }else{
      forgotRequestFinal({
        email,
        password,
        code
      })
        .then(async (response) => {
          setLoading(false);
          setError("");
          setSuccess("Şifreniz değiştirildi");
          setEmail("");
          setMode(1)
          setPassword("")
          setCode("")
        })
        .catch((error) => {
          setError(error.response?.data?.message);
          setLoading(false);
        });
    }
  };
  const changeLoginPopUp = () => {
    setEmail("")
    setPassword("")
    setCode("")
    setSuccess("")
    setError("")
    setMode(1)
    dispatch(setForgotPopUp());
    dispatch(setLoginPopUp());
  };

  if (!open) {
    return <></>;
  }
  return (
    <LoginBoxContent register={true} onClick={() => setOpen(false)}>
      <div className="box" onClick={(e) => e.stopPropagation()}>
        <div className="close" onClick={() => setOpen(false)}>
          <FontAwesomeIcon icon={faTimes} />
        </div>
        <img
          className={"robotkafasi" + (hide ? " hide" : " show")}
          src={robotkafasi}
        />

        <form autoComplete="off" onSubmit={loginIn}>
          <h1>Şifre Sıfırlama Formu</h1>

          {mode == 2 ? (
            <>
              <div className="form-box">
                <input
                  type="text"
                  placeholder="Doğrulama Kodu"
                  value={code}
                  onChange={(e) =>setCode(e.target.value)}
                />
              </div>

              <div className="form-box">
                <input
                  type="password"
                  placeholder="Şifre"
                  value={password}
                  onChange={(e) => setPassword(e.target.value)}
                />
              </div>
            </>
          ) : (
            <div className="form-box">
              <input
                type="text"
                placeholder="E Posta"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
              />
            </div>
          )}

          {error && (
            <div className="error-area">
              <FontAwesomeIcon
                icon={faExclamationTriangle}
                style={{ marginRight: 20 }}
              />
              <span>{error}</span>
            </div>
          )}
          {success && (
            <div className="success-area">
              <FontAwesomeIcon icon={faCheck} style={{ marginRight: 20 }} />
              <span>{success}</span>
            </div>
          )}
          {loading == true ? (
            <Sentry size={20} color="green" />
          ) : (
            <button type="submit">{mode==1 ? 'Doğrulama Kodu Gönder':'Şifremi Değiştir'}</button>
          )}
        </form>
        <div
          onClick={changeLoginPopUp}
          style={{
            paddingBottom: 10,
            textAlign: "center",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
          }}
        >
          Şifreni hatırladın mı ?{" "}
          <div style={{ marginLeft: 5, fontWeight: "bold", cursor: "pointer" }}>
            Giriş Yap
          </div>
        </div>
      </div>
    </LoginBoxContent>
  );
}
